module.exports = __webpack_public_path__ + "img/1-on.ccf08096.png";